import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { RootShareRecommendations } from './getShareRecommendations';
import { getShareRecommendations } from './getShareRecommendations';

type Result = QueryHookResult<{ data: RootShareRecommendations }>;

export type {
	FacebookShareRecommendations,
	RedditShareRecommendations,
	RootShareRecommendations,
} from './getShareRecommendations';

export function useFetchShareRecommendations(slug: string): Result {
	const utilityContext = useUtilityContext();
	return useQuery(async () => ({ data: await getShareRecommendations(utilityContext, slug) }), [utilityContext, slug]);
}
